import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import Button from 'components/Button/Button';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { UserRoles } from 'types';
import { IUserProfileContext, UserProfileContext } from '../../../../../userProfileState/userProfileContext';
import style from './EditBtn.module.scss';

const EditBtn: React.FC = () => {
	const { userForUserInfo } = useContext<IUserProfileContext>(UserProfileContext);
	const hasAccess = useRoleAccess([UserRoles.SUPER_USER]);

	return (
		<Link to={`/users/edit?userID=${userForUserInfo?.id}`}>
			<Button
				className={style.btn}
				theme="primaryBlue"
				icon={
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#pencil`} />
					</svg>
				}
				disabled={!hasAccess}>
				<Text translationNameSpace="form" translationKey="editUserButton" asFragment={true} />
			</Button>
		</Link>
	);
};

export default EditBtn;
